module.exports = __webpack_public_path__ + "img/ce0d9e75b77d7efb9234a479a1e227c.979fb288.jpg";